import React, {
  useState,
  useEffect
} from 'react';

import {SiteLinks} from '../../general';

function ThesisProposalPageInfo() {
  return (<SiteLinks screen="s2_student_proposal" />);
}

export {ThesisProposalPageInfo};